export const CSS_CLASS = {
  CLOSE: 'react-modal-Close',
  MODAL: 'react-modal-Modal',
  OVERLAY: 'react-modal-Overlay',
  REMOVE_SCROLL: 'react-modal-Html-remove-scroll'
}
